import { useRef, useState } from 'react';
import { downloadPdf } from '../../functions/downloadPdf';

const PdfDownload = ({ href, filename, children, compact = false }) => {
  const pending = useRef(false);
  const [status, setStatus] = useState('');
  const handleDownload = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (pending.current) return;
    pending.current = true;
    setStatus('Preparando PDF…');
    try {
      await downloadPdf(href, filename);
      setStatus('Download iniciado. Confira Downloads.');
    } catch {
      setStatus('Não foi possível baixar. Use “Abrir PDF”.');
    } finally {
      pending.current = false;
    }
  };
  return (
    <div className={`pdf-download${compact ? ' pdf-download-compact' : ''}`}>
      <div className="pdf-download-actions">
        <a className={compact ? undefined : 'retro-link-button'} href={href} download={filename} onClick={handleDownload}>{children}</a>
        <a href={href} target="_blank" rel="noopener noreferrer">Abrir PDF ↗</a>
      </div>
      <span className="pdf-download-status" role="status" aria-live="polite">{status}</span>
    </div>
  );
};

export default PdfDownload;
